export interface StateType {
  formData: {
    userName: string;
    idCardNo: string;
  };
}

/** 二要素字段枚举 */
export enum TwoFactorFieldEnum {
  /** 姓名 */
  USER_NAME = 'userName',
  /** 身份证号 */
  ID_CARD_NO = 'idCardNo',
}
